/* @flow */
import actionTypes from '../actions/actionsFactory/types';

const INITIAL_STATE = {
  blogPage: 1,
  blogTotal: 0,
  blogList: [],
  blogDetail: {},
  blogError: false,
  isLoading: false,
};

const handleBlogList = data => ({
  blogTotal: data.total,
  blogList: data.data,
});

const handleBlogListH5 = (data, preData) => ({
  blogTotal: data.total,
  blogList: preData.blogList.concat(data.data),
});

export const reducer = (state:any = INITIAL_STATE, action:any) => {
  switch (action.type) {
    case actionTypes.SET_BLOG_PAGE_SUCCESS:
      return { ...state, blogPage: action.data, isLoading: true };
    case actionTypes.GET_BLOG_LIST_SUCCESS:
      if (action.pageType === 'h5') {
        return {
          ...state,
          ...handleBlogListH5(action.data, state),
          isLoading: false,
        };
      }
      return { ...state, ...handleBlogList(action.data), isLoading: false };
    case actionTypes.GET_BLOG_DETAIL_SUCCESS:
      return { ...state, blogDetail: action.data, blogError: false };
    case actionTypes.GET_BLOG_DETAIL_ERROR:
      return { ...state, blogError: true };
    default:
      return state;
  }
};

export default {};
